import angular from "angular"
import { getToken, getDecoded } from "../../lib/servicetoken"
const ServiceTokenSrv = () => {
  return { getToken, getDecoded }
}

angular.module("uCountitUiApp").service("ServiceTokenSrv", ServiceTokenSrv)
